import { get } from '../utils/api';
export default class ProrateMethodsService {
  getMoveOutProratedTransactions(householdId: string) {
    return get(`/households/${householdId}/move-out-prorated-transactions`);
  }
}
